import Reveal from '../../../shared/Reveal/Reveal';
import { useInfrastructureGlobalContent } from '../../../../hooks/useInfrastructureGlobalContent';
import worldMap from '../../../../assets/images/infrastructure/global/world.svg';
import './Global.css';

const Global = () => {
  const { content, isLoading } = useInfrastructureGlobalContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, text, image } = content;

  return (
    <section className="infrastructure-global">
      <div className="infrastructure-global__inner">
        <Reveal className="infrastructure-global__copy">
          <h2 className="infrastructure-global__title">{title}</h2>
          {text ? <p className="infrastructure-global__text">{text}</p> : null}
        </Reveal>

        <Reveal className="infrastructure-global__media" delay={80}>
          <img
            className="infrastructure-global__image"
            src={image || worldMap}
            alt=""
            aria-hidden="true"
          />
        </Reveal>
      </div>
    </section>
  );
};

export default Global;
